var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManHairstyle4E(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 720 720",
    enableBackground: "new 0 0 720 720",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "frame_730px"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.8,
    y: -4.9,
    fill: "none",
    stroke: "#0000FF",
    strokeWidth: 0.25,
    strokeOpacity: 0,
    width: 730,
    height: 730
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Man_x5F_hair:"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x34__2_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M475.7,155.9c-0.8-1.7-1.6-3.3-2.5-4.8c-3.4-5.7-8.1-10.6-14.1-13.6c2.6-7.6-2.2-16.8-7.8-22.1 c-10.2-8.9-21.9-15.5-34.2-19.3c-2.5-0.8-5-1.4-7.5-1.9c-8.4-2.3-16.9-3.7-25.4-4.4c-2.8-0.2-5.7-0.4-8.6-0.5 c-19.2-0.4-39,1-58.1,6c-2.7,0.7-5.4,1.5-8.1,2.3c-25.4,9.2-49.8,25.1-59.2,50.4c-1,2.2-1.8,4.5-2.6,6.7 c-1.2,3.4-2.2,6.9-3.1,10.5c-3,12.3-3.4,24.5-1.7,36.6c0.3,2.4,0.7,4.8,1.2,7.2c3.1,17.3,10.7,33.2,15.7,49.7 c0-20.1,9.3-40,26.3-52.4c19-13.8,40.6-27.3,63-34.9c-19.5,12.2-35.1,23.8-52.7,34.5c15.9-2.1,25.9-5.4,38.8-9.9 c11.7-4.1,31.5-10.3,41.3-17.6c-15.3,12-30.5,25.4-49.8,31.4c12,1.7,26.7-2.7,38-6.4c12.2-4,21-7.7,32.9-12.8 c8.1-3.4,25.8-11.4,35.8-18c11.4,14,12.5,33.4,14.5,50.2c0.2,2.1,0.3,4.1,0.5,6.2c0.3,4.1,0.8,8.2,1.5,12.2 c0.3,1.7,0.5,3.4,0.7,5.2c0.9,6.1,1.9,12.6,3.9,18.7c1.6-10.1,5.5-19.2,10.3-28c0.8-1.5,1.7-3.1,2.6-4.6 c4.6-6.1,7.6-12.6,9.5-19.4c0.5-1.7,0.9-3.4,1.3-5.1C481.1,190.9,484.5,171.7,475.7,155.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#3D3433",
    d: "M347,105.8c-34.9,3.4-63.7,23.2-82.6,52c-18.4,30.4-15.7,64.8-4.5,94.1c0.5-4.3,1.3-8.6,2.6-12.7 C246.3,174.5,288.3,120.9,347,105.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3D3433",
    d: "M312.9,175.1c4.1-2.2,10.8-5.5,15.1-7.4c29.2-13.7,66.5-20.6,81.1-47c-26.6,18.1-58.7,21.3-87.1,34.7 c-4.9,2.3-9.6,4.7-14.2,7.4c-26.2,15.4-46,37.7-42.2,68.6c2.7-5.8,6.2-11.2,10.5-16C282.3,196.9,295.8,184.4,312.9,175.1z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#3D3433",
    d: "M442.6,144.1c-26.7,22.8-58,38.4-89.8,52.5c-8.1,5.5-16.6,10.4-26.2,13.3c12,1.7,26.7-2.7,38-6.4 c12.2-4,21-7.7,32.9-12.8c3.2-1.4,7.9-3.4,13.1-5.8C423.8,173.4,434.7,159.6,442.6,144.1z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManHairstyle4E);
export default __webpack_public_path__ + "static/media/man_hairstyle_4e.aecaa85392ed7330ca43e47c93e49f5c.svg";
export { ForwardRef as ReactComponent };